var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("nav",function(){return [_c('WizardNav',_vm._b({},'WizardNav',_vm.navProps,false))]}),_vm._t("default",null,{"transitioning":_vm.transitioning})],2)}
var staticRenderFns = []

export { render, staticRenderFns }